import React from 'react';
import { Link } from 'react-router-dom';

import { USER_ROLES } from '@pwc/pwc-deals-web-common';
import { useSelector } from 'react-redux';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import featureFlags from '../../common/helpers/featureFlags';
import { useSmallScreen } from '../../common/hooks/useMobile';
import MobileBreadcrumbs from './MobileBreadcrumbs';
import styles from './MobileBreadcrumbs.module.scss';

const MAX_CHAR_COUNT = 14;
const INDEX_TO_APPLY_TRUNCATION = 4;

const Breadcrumbs = ({ breadcrumbs }) => {
  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;
  const isSmallScreen = useSmallScreen();

  const handleLink = (path, text) => {
    if (text.includes('Topic')) {
      const isClientUser = !isPwcUser;
      const isSharedOrDraft = isClientUser ? 'shared' : 'draft';
      const crumbPath = path.split('/');
      const tempPath = `${crumbPath
        .slice(0, crumbPath.indexOf('topic'))
        .join('/')}/topics/${isSharedOrDraft}`;
      return tempPath;
    }
    return path;
  };

  if (
    featureFlags.isGlobalToggleEnabled &&
    isSmallScreen &&
    breadcrumbs.length > 1
  ) {
    return (
      <>
        <span key={breadcrumbs[0].path}>
          <Link
            to={handleLink(breadcrumbs[0].path, breadcrumbs[0].text)}
            className="breadcrumb-link"
          >
            {breadcrumbs[0].text}
          </Link>
        </span>

        <MobileBreadcrumbs
          breadcrumbs={breadcrumbs.filter(
            (crumb, index) => index > 0 && index < breadcrumbs.length - 1
          )}
          handleLink={handleLink}
        >
          <span className={styles['mobile-breadcrumb-link']}>...</span>
        </MobileBreadcrumbs>

        <span
          className="breadcrumb-text"
          key={breadcrumbs[breadcrumbs.length - 1].path}
        >
          {breadcrumbs[breadcrumbs.length - 1].text.length >= MAX_CHAR_COUNT &&
          breadcrumbs.length >= INDEX_TO_APPLY_TRUNCATION
            ? `${breadcrumbs[breadcrumbs.length - 1].text.slice(
                0,
                MAX_CHAR_COUNT
              )}...`
            : breadcrumbs[breadcrumbs.length - 1].text}
        </span>
      </>
    );
  }

  return breadcrumbs.map((crumb, index) => {
    const testId = `breadcrumb-${crumb.text.toLowerCase().replace(/ /g, '-')}`;

    return index === breadcrumbs.length - 1 ? (
      <span className="breadcrumb-text" data-testid={testId} key={crumb.path}>
        {featureFlags.isGlobalToggleEnabled &&
        isSmallScreen &&
        crumb.text.length >= MAX_CHAR_COUNT &&
        breadcrumbs.length >= INDEX_TO_APPLY_TRUNCATION
          ? `${crumb.text.slice(0, MAX_CHAR_COUNT)}...`
          : crumb.text}
      </span>
    ) : (
      <span key={crumb.path}>
        <Link
          to={handleLink(crumb.path, crumb.text)}
          data-testid={testId}
          className="breadcrumb-link"
        >
          {crumb.text}
        </Link>
      </span>
    );
  });
};

export default Breadcrumbs;
